import React from 'react';

import { Column, Row } from 'app/shopify/components/layout';

import { Avatar, type AvatarSize, type AvatarTint } from './Avatar';

const SIZES: AvatarSize[] = [16, 20, 24, 32, 40, 48, 56];
const TINTS: AvatarTint[] = [
  'brand-alt',
  'brand-secondary-1',
  'brand-secondary-2',
  'brand-secondary-3',
  'brand-secondary-4',
  'brand-secondary-5',
];

export function AvatarShowcase() {
  return (
    <Column gap="spacing.general.x3" padding="spacing.general.x4">
      <Row gap="spacing.general.x3">
        {SIZES.map((size) => (
          <Avatar key={`img-rounded-${String(size)}`} media="image" style="rounded" size={size} />
        ))}
      </Row>

      <Row gap="spacing.general.x3">
        {SIZES.map((size) => (
          <Avatar key={`img-squared-${String(size)}`} media="image" style="squared" size={size} />
        ))}
      </Row>

      {TINTS.map((tint) => (
        <Row key={`rounded-${tint}`} gap="spacing.general.x3">
          {SIZES.map((size) => (
            <Avatar
              key={`${tint}-rounded-${String(size)}`}
              media="text"
              style="rounded"
              size={size}
              tint={tint}
              initials="HL"
            />
          ))}
        </Row>
      ))}

      {TINTS.map((tint) => (
        <Row key={`squared-${tint}`} gap="spacing.general.x3">
          {SIZES.map((size) => (
            <Avatar
              key={`${tint}-squared-${String(size)}`}
              media="text"
              style="squared"
              size={size}
              tint={tint}
              initials="HL"
            />
          ))}
        </Row>
      ))}
    </Column>
  );
}
